<template>
  <div>
    <v-container fluid>
      <v-row justify="space-around">
        <v-col cols="12" lg="6" class="my-2 pa-0">
          <v-data-table :headers="dTableHeaders" 
                        :items="dLogs" 
                        :item-key="dItemKey" 
                        :noDataText="$t('datGeneric.noData')" 
                        :loading-text="$t('datGeneric.loading')" 
                        :header-props="dHeaderProps"
                        :options.sync="dPagination" 
                        :server-items-length="dTotalRows" 
                        :items-per-page="10" 
                        :footer-props="{'items-per-page-options':[5,10,20], 'items-per-page-text': $t('labels.elementsPerPage'), 'pageText': '{0}-{1} de {2}' }" 
                        class="datTable"
                          >
            <!-- Fecha formateada -->
            <template v-slot:[`item.creationDate`]="{ item }">
              <v-row class="ma-0">
                <v-col cols="auto" class="pa-0">
                  <span class="mt-4">{{ fDateFormat(item.creationDate) }}</span>
                </v-col>
              </v-row>
            </template>   
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>

//Servicios y mixins
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'
import ServiceEcomplaints from '@/services/srv-eComplaints'

export default {
  mixins: [mxCanalDenuncias],

  props: {
    pComplaintInfo:{
      type: Object,
      required: false
    },
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    }
  },

  mounted(){ 
    this.fGetComplaintAccess()
  },

  data () {
    return {
      dItemKey: 'rn',
      dLogs:[],
      dTotalRows: 1,
      dPagination: null,
      dTableHeaders: [
        {
          text: this.$t('labels.name'),
          value: 'userName',
          align: 'left',
          sortable: true,
          class: '',
        },{
          text: this.$t('labels.creationDate'),
          value: 'creationDate',
          align: 'left',
          sortable: true,
          class: '',
        }
      ],
      dHeaderProps: {sortByText: this.$t('datGeneric.sortBy')}
    }
  },
  methods: {
    //Muestra los accesos de una denuncia 
    fGetComplaintAccess(){
      let payload = {
        complaintId: this.pComplaintInfo.complaintId,
        numRows: this.dPagination.itemsPerPage,
        offset: ((this.dPagination.page-1) * this.dPagination.itemsPerPage) + 1,
        orderBy: this.dPagination.sortBy[0] ? this.dPagination.sortBy[0] : 'creationDate',
        order: this.dPagination.sortDesc[0] ? 'ASC' : 'DESC',
      }

      ServiceEcomplaints.getComplaintAccess(payload).then(response => {
        if (response.statusCode == '200' && response.result != 'ko'){
          this.dLogs = response.dataRes
          this.dTotalRows = response.numReg
        }
      }).catch(error => {
        this.fSnackbarError(error, this.pShowSnackbar)
      })
    }
  },

  watch:{
    dPagination(){
      this.fGetComplaintAccess()
    }
  }
}
</script>